import { Button } from './Button';

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorState = ({ message, onRetry }: ErrorStateProps) => (
  <div className="flex h-full min-h-[240px] w-full flex-col items-center justify-center px-6 text-center">
    <h1 className="text-2xl font-semibold">Something went wrong</h1>
    <p className="mt-3 max-w-xl text-lg text-app-muted">{message}</p>
    {onRetry && (
      <Button
        className="mt-6"
        data-focus-key="error:retry"
        data-focus-preferred="true"
        onClick={onRetry}
      >
        Try again
      </Button>
    )}
  </div>
);
